import type { RowData } from "@tanstack/react-table";
import { type JSX, memo, useMemo } from "react";

import styles from "../styles.module.scss";

import type { IRowComponentProps } from "@components/organisms/table/types";
import type { IWithId } from "@components/organisms/formListBox";
import { CellComponent } from "@components/organisms/table/tbody/cellComponent";
import { getCellKey } from "@components/organisms/table/tbody/helper";

export const RowComponent = memo(function RowComponent<TData extends RowData>({
  rowEl,
  showRow,
  index,
}: IRowComponentProps<TData>) {
  const rowColumn = useMemo(
    () =>
      showRow && (
        <td className={styles.td}>
          <div className={styles.cell}>{index + 1}</div>
        </td>
      ),
    [index, showRow],
  );

  const cells = useMemo(() => rowEl.getVisibleCells(), [rowEl]);
  const cellsComponent = useMemo(
    () =>
      cells?.map((cellEl) => {
        return <CellComponent key={getCellKey(cellEl)} cellEl={cellEl} />;
      }),
    [cells],
  );

  return (
    <tr
      key={`${(rowEl.original as IWithId<object>).id || rowEl.id}`}
      className={styles.tr}
    >
      {rowColumn}
      {cellsComponent}
    </tr>
  );
}) as <TData extends RowData>(props: IRowComponentProps<TData>) => JSX.Element;
